import React, { useEffect, useState } from "react";
import "./css/Director.css";

const Director = () => {
  const [director, setDirector] = useState({
    name: '',
    message: '',
    image: '',
  });

  useEffect(() => {
    const fetchDirector = async () => {
      try {
        const res = await fetch("https://cms.maitretech.com/seedlingschoolbhopal/items/director?fields=*.*.*");
        const data = await res.json();
        const item = data?.data?.[0];

        if (item) {
          const imageUrl = item?.profile_pic?.data?.full_url?.replace("http://", "https://");
          setDirector({
            name: item.name || '',
            message: item.message || '',
            image: imageUrl || '',
          });
        }
      } catch (error) {
        console.error("Failed to fetch director data:", error);
      }
    };

    fetchDirector();
  }, []);

  return (
    <div className="director-sid">
      <div className="director-sid-row">
        <div className="director-sid-col">
          {director.image && <img src={director.image} alt={director.name} />}
          <h4>{director.name}</h4>
        </div>
        <div className="director-sid-col">
          <h2>Director Message</h2>
          <h6>{director.message}</h6>
        </div>
      </div>
    </div>
  );
};

export default Director;
